import {
  DistributionType,
} from "~src/pages/brands/Detail/TrafficAndRevenue";
import { TrafficData } from "~src/types/brand";
import { logError } from "~src/utils/logger";
export type GraphData = {
  date: string[];
  revenue: number[];
  visitors: number[];
};

export const generateAudienceDemographicsGraphData = (
  graphData: DistributionType | undefined,
) => {
  if (graphData?.AgeDistribution) {
    const keys = Object.keys(graphData.AgeDistribution);
    const values = Object.values(graphData.AgeDistribution).map((value) =>
      parseFloat(value.replace("%", "")),
    );
    const largeValueIndex = values.indexOf(Math.max(...values));
    const largestAgeGroup = keys[largeValueIndex];

    const isValidValues = values.every((value) => !isNaN(value));

    return { values, keys, largestAgeGroup, isValidValues };
  }
};

export const generateColors = (values: number[] | undefined) => {
  if (!values || values.length === 0) return [];
  const maxVal = Math.max(...values);
  const minVal = Math.min(...values);

  return values.map((value) => {
    const intensity = ((value - minVal) / (maxVal - minVal)) * 255;
    return `rgba(61, 115, 255, ${0.3 + (intensity / 255) * 0.7})`;
  });
};

export const generateGenderGraphData = (
  graphData: DistributionType | undefined,
) => {
  if (graphData?.GenderDistribution) {
    const keys = Object.keys(graphData.GenderDistribution);
    const values = Object.values(graphData.GenderDistribution).map((value) =>
      parseFloat(value.replace("%", "")),
    );
    const formattedLabels = keys.map(
      (key, index) => `${values[index]}% ${key}`,
    );
    const isValidValues = values.every((value) => !isNaN(value));

    return { values, formattedLabels, isValidValues };
  }
};

export const generateGraphData = (
  data?: TrafficData,
): GraphData | undefined => {
  const graphData: GraphData = { date: [], revenue: [], visitors: [] };
  if (data) {
    if (data.traffic_overview_data && data.revenue_overview_data) {
      graphData.date = Object.keys(data.traffic_overview_data).map(
        (key) => key,
      );
      graphData.visitors = Object.values(data.traffic_overview_data);
      graphData.revenue = Object.values(data.revenue_overview_data);
    }
  }

  return graphData;
};

export const getLatestData = (
  data: Record<string, Record<string, string>> | undefined | null,
): any => {
  if (!data) {
    return undefined;
  }

  const dataArray: [string, Record<string, string>][] = Object.entries(data);

  if (dataArray.length === 0) {
    return undefined;
  }

  try {
    dataArray.sort(
      ([dateA], [dateB]) => new Date(dateB).getTime() - new Date(dateA).getTime(),
    );

    return dataArray[0] && dataArray[0][1] 
      ? dataArray[0][1] 
      : undefined;
  } catch (error) {
    logError(`Error sorting data by date: ${error}`);
    return undefined;
  }
};
